export enum VatPayerValue {
    YES = 'Yes',
    NO = 'No'
}



// WEBPACK FOOTER //
// ./src/app/common/enums/vatpayer-value.enum.ts